import { useMediaQuery } from "@material-ui/core";
import React from "react";

interface Props {
  loginPage?: boolean;
}

const ChartLoader = (props: Props) => {
  const { loginPage } = props;

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  const chartMargin = matchesMediaQuery ? 60 : 35;

  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 200 200"
      color="#003366"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: loginPage ? 0 : chartMargin }}
    >
      <defs>
        <linearGradient id="spinner-secondHalf">
          <stop offset="50%" stopOpacity="0" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
        <linearGradient id="spinner-firstHalf">
          <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
          <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
      </defs>

      <g strokeWidth="10">
        <path
          stroke="url(#spinner-secondHalf)"
          d="M 4 100 A 96 96 0 0 1 196 100"
        />
        <path
          stroke="url(#spinner-firstHalf)"
          d="M 196 100 A 96 96 0 0 1 4 100"
        />

        <path
          stroke="currentColor"
          strokeLinecap="square"
          d="M 4 100 A 96 96 0 0 1 4 98"
        />
      </g>

      <animateTransform
        from="0 0 0"
        to="360 0 0"
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1300ms"
      />
    </svg>
  );
};

export default React.memo(ChartLoader);
